<template>
  <div>
    <div
      :ref="controlRef"
      :style="{ width: setWidth, height: setHeight }"
    >
      <div
        v-show="editingMode"
        class="flex items-center w-full h-full"
      >
        <div
          id="options"
          class="ms-combobox flex w-full h-full"
          :class="{ isValid: errorProvider.isValid, disabled: disabled }"
          :title="internalText"
        >
          <div
            v-if="showIconInput"
            class="h-full"
          >
            <slot
              name="avatar"
              :data="dataInfo"
            />
          </div>
          <input
            ref="input"
            v-model="internalText"
            class="ms-input"
            :placeholder="placeholder"
            :class="{ 'input-disabled': disabled }"
            :disabled="disabled"
            :autofocus="autofocus"
            :tabindex="tabindex"
            :scrollParent="scrollParent"
            v-on="listeners"
            @keyup.tab="handleClickExpandIcon"
            @click="handleClickExpandIcon"
          >
          <!-- <ms-tooltip v-if="!disabled && errorProvider.isValid" :showTooltips="false">
            <div class="icon-input" style="padding-right: 0px !important;">
              <div class="mi mi-20 mi-icon-error mr-2"></div>
            </div>
          </ms-tooltip> -->
          <div
            class="icon-combo--dropdown"
            :class="{ disabled: disabled, 'no-border': !hasBorderLeft }"
            @click="handleClickExpandIcon"
          >
            <div
              v-show="showIconDrop"
              :class="['mi-chevron-down']"
            />
          </div>
          <!-- <transition name="dropdownx"> -->
          <ms-combo-box-dropdown
            v-if="expanded"
            ref="dropdownPanel"
            :topx="dropdownTopx"
            :leftx="dropdownLeftx"
            :max-widthx="dropdownMaxWidthx"
            :min-widthx="dropdownMinWidthx"
            :columnx="columns"
            :combo-type="comboType"
            :loading="loading"
            :show-empty-text="showEmptyText"
            :use-add-new="useAddNew"
            :new-item-text="internalText"
            @onAddNew="doAddNew"
          >
            <MsRecycleScroller
              v-if="internalDataSource.length > 0"
              ref="scroller"
              :style="styleScroller"
              :items="internalDataSource"
              :item-size="itemSize"
              key-field="__vKeyValue"
              :emit-update="true"
              :buffer="0"
              :visiable-index="typeAheadPointer"
              :remain-items="queryMode == 'local'"
              @visible="onScrollerVisible"
              @update="onScrollerUpdate"
            >
              <!-- :visiableIndex="typeAheadPointer" -->
              <!-- @visible="onScrollerVisible" -->
              <template #default="{ item, index }">
                <ms-combo-box-item
                  :combo-type="comboType"
                  :item="item"
                  :columnx="columns"
                  :value-field="valueField"
                  :display-field="displayField"
                  :class="{
                    'ms-combobox-item--highlight':
                      value == item[valueField] || typeAheadPointer == index
                  }"
                  :insert-h-t-m-l="insertHTML"
                  @click.stop="onItemClick(item, $event)"
                >
                  <template #item>
                    <slot
                      name="item"
                      :data="item"
                    />
                  </template>
                </ms-combo-box-item>
                <!-- :removeButton="hasRemoveItemButton" -->
                <!-- :class="{'combobox-item--highlight': (typeAheadPointer == index)}" -->
                <!-- @click="onItemClick(item,$event)"
                @removeItem="onRemoveItemClick(item)"-->
                <!-- :align="internalAlign" -->
              </template>
            </MsRecycleScroller>
          </ms-combo-box-dropdown>
          <!-- </transition>    -->
        </div>
        <div
          v-if="editable"
          ref="btn-save-cancel"
          class="flex m-l-8"
        >
          <ms-icon
            icon="mi-file-green"
            :tooltip-content="$t('i18nCommon.Save')"
            @click="saveEditMode"
          />
          <ms-icon
            icon="mi-circle-close-red"
            :tooltip-content="$t('i18nCommon.Cancel2')"
            @click="closeEditMode"
          />
        </div>
      </div>
      <div
        v-show="editable && !editingMode"
        class="flex"
        @dblclick="onDoubleClick"
      >
        <ms-text-border class="text-border">
          <slot
            v-if="!internalText"
            name="noData"
          />
          <span
            v-else
            :title="internalText"
          >{{ internalText }}</span>
          <template #icon>
            <ms-icon
              v-if="!permission"
              icon="mi-lock"
            />
            <ms-icon
              v-if="permission"
              icon="mi-pencil"
              :tooltip-content="$t('i18nCommon.Edit')"
              @click="clickEditBtn"
            />
          </template>
        </ms-text-border>
      </div>
    </div>
    <p
      v-if="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import _ from "lodash";
// import MsComboBoxItem from "../ms-combobox/MsComboBoxItem.vue";
// import MsComboBoxDropdown from "./MsComboBoxDropdown.vue";
import MsRecycleScroller from "../../shared/virtualScroller/MsRecycleScroller.vue";
import commonFunc from "../../../commons/commonFunction";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsCombobox",
  components: {MsRecycleScroller},
  extends: msBaseComponent,
  props: {
    value: {},
    // Loại của combox hcphi thêm
    typeCombox: {
      default: 1,
      type: Number
    },
    placeholder: {
      default: null,
      type: [Number, String]
    },
    maxItemsDisplay: {
      default: 5,
      type: Number
    },
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * Trường làm value
     * CreatedBy LTDAT 15.06.2020
     */
    valueField: {
      type: String,
      default: null
    },
    /**
     * Trường làm text display
     * CreatedBy LTDAT 15.06.2020
     */
    displayField: {
      type: String,
      default: null
    },
    /**
     * Trường làm text cho ô input trong TH dữ liệu trong các combo item là HTML
     */
    displayFieldForInput: {
      type: String,
      default: null
    },
    //Dữ liệu của combobox
    data: {
      default: () => [],
      type: Array
    },
    //Lưu dữ liệu định danh combobox
    dataInfo: {
      default: () => {},
      type: Object
    },
    //Độ rộng của 1 item
    itemSize: {
      default: 32,
      type: Number
    },
    //Chỉ nhận giá trị có trong danh sách
    forceSelection: {
      default: true,
      type: Boolean
    },
    //Là combotree hay không
    isComboTree: {
      default: false,
      type: Boolean
    },
    //Parent Field
    idProperty: {
      default: null,
      type: String
    },
    // nơi sử dụng
    whereUse: {
      type: String,
      default: ""
    },
    //Field chứa parentID
    parentIdProperty: {
      default: "ParentID",
      type: String
    },
    //Không cho phép chọn trường là cha
    notSelectionParent: {
      default: false,
      type: Boolean
    },
    //Độ rông của dropdown tính bằng px
    dropdownWidth: {
      default: null,
      type: [String, Number]
    },
    //Store xử lý dữ liệu trên liên quan đến data trong grid
    store: {
      default: null
    },
    //Mode query lấy dữ liệu từ server hay client
    queryMode: {
      type: String,
      default: "remote"
    },
    //Gán giá trị text lúc ban đầu
    initText: {
      default: null,
      type: [Number, String]
    },
    //Trạng thái có phân trang hay không
    pagination: {
      default: false,
      type: Boolean
    },
    //Combo mặc định chọn bản ghi theo index
    initIndex: {
      default: -1,
      type: Number
    },
    disabled: {
      default: false,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    },
    display: {},
    //Tổng số bản ghi
    pageTotal: {
      default: 0,
      type: Number
    },
    // Dữ liệu chèn vào combox item có là HTML
    insertHTML: {
      default: false,
      type: [String, Boolean]
    },
    hasBorderLeft: {
      type: [String, Boolean],
      default: false
    },
    // function để call API lấy các list options
    doQueryFuntion: Function,
    // các cột được search khi call API
    searchColums: Array,
    // có sử dụng tính năng thêm khi search không có dữ liệu hay không
    useAddNew: {
      type: [String, Boolean],
      default: false
    },
    // dữ liệu mới được thêm khi sử dụng useAddNew = true
    newAddedItem: {
      type: Object,
      default: null
    },
    // hàm thêm
    doAddFunction: Function,
    // có call lại API không
    isReloadQueryFuntion: {
      type: [String, Boolean],
      default: false
    },
    autofocus: {
      default: false,
      type: [Boolean, String]
    },
    tabindex: {
      default: 1,
      type: [String, Number]
    },
    width: {
      default: "auto",
      type: [String, Number]
    },
    height: {
      default: 36,
      type: [String, Number]
    },
    hideEmptyText: {
      type: [Boolean, String],
      default: false
    },
    paramValidate: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    },
    showIconDrop: {
      type: Boolean,
      default: true
    },
    showIconInput: {
      type: Boolean,
      default: false
    },
    permission: {
      type: Boolean,
      default: true
    },
    // có sử dụng bỏ dấu của tiếng việt khi search (th query = remote)
    useSlug: {
      type: Boolean,
      default: false
    },
    // tự động chọn item đầu tiên khi dữ liệu trống
    autoSetFirstItemWhenEmpty: {
      type: Boolean,
      default: false
    },
    // sửa dụng i18n cho combobox
    useI18nValue: {
      type: Boolean,
      default: false
    },
    // sử dụng cho sự kiện scroll cha thì ẩn combobox chọn đi
    scrollParent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const me = this;
    me.initStaticData();
    return {
      internalDataSource: [],
      controlRef: MsControlRef.MsCombobox,
      internalText: null,
      expanded: false,
      dropdownTopx: 0,
      dropdownLeftx: 0,
      internalSelectedItem: null,
      typeAheadPointer: -1,
      focused: false,
      loading: false,
      showEmptyText: false,
      isReloadQueryFuntionTemp: this.isReloadQueryFuntion,
      timeoutAmount: 100,
      mode: false,
      pageTotalx: this.pageTotal,
      timeoutQuery: null,
      timeoutClickOutside: null,
      // set chế độ edit = fasle khi editable = true
      editingMode: !this.editable,
      oldValue: null,
      // có cho phép kích hoạt sự kiện blur
      isAllowBlurEvent: true,
      initTextX: this.initText,
      dataTemp: []
    };
  },
  computed: {
    listeners() {
      const me = this;
      return {
        input: event => me.onInput(event),
        focus: event => me.onFocus(event),
        change: event => me.onChange(event),
        blur: event => me.onBlur(event),
        keydown: event => me.onKeydown(event)
      };
    },
    //Tính độ rộng của dropdown combobox để scroll
    styleScroller() {
      const me = this;
      return { "max-height": me.maxItemsDisplay * me.itemSize + "px" };
    },
    setWidth() {
      if (!isNaN(this.width)) {
        return this.width + "px";
      }
      return this.width;
    },
    setHeight() {
      if (!isNaN(this.height)) {
        return this.height + "px";
      }
      return this.height;
    },
    isEditingMode() {
      return this.$store.getters.getEditingMode;
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.dataTemp = this.$function._cloneDeep(this.data);
        if (newVal != me.internalDataSource) {
          me.initData();
        }
        if (!newVal || (newVal && newVal.length == 0)) {
          this.showEmptyText = true;
        } else {
          this.showEmptyText = false;
        }
      }
    },
    /**
     * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
     */
    initText: {
      immediate: true,
      handler(newVal, oldVal) {
        let me = this;
        if (newVal || oldVal) {
          me.setInitText(newVal);
        }
        if (me.useI18nValue && me.internalText) {
          me.internalText = me.$function.handleLocalize(me.internalText);
        }
      }
    },
    /**
     * Kiểm tra nếu text hiện thị thay đổi thi validate
     */
    internalText: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        newVal = newVal ? newVal : "";
        oldVal = oldVal ? oldVal : "";
        if (newVal != oldVal) {
          // me.validate(newVal);
        }
        // me.$emit('input',newVal);
        if (this.useI18nValue && this.internalText) {
          this.internalText = this.$function.handleLocalize(this.internalText);
        }
      }
    },
    /**
     * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
     */
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (newVal != null && newVal != undefined) {
          me.internalValue = newVal;
          if (
            !me.internalSelectedItem ||
            me.internalSelectedItem[me.valueField] != newVal
          ) {
            if (me.internalDataSource != me.data && me.queryMode == "local") {
              me.initData();
            }
            me.doHightlightItem();
            if (me.typeAheadPointer >= 0) {
              me.setInternalItem(
                me.internalDataSource[me.typeAheadPointer],
                false
              );
            }
          }
        } else {
          !this.initTextX && me.reset();
        }
      }
    },

    /**
     * custom validate
     * edit by nvhieu 24/3/2021: Thêm watch deep
     */
    paramValidate: {
      immediate: true,
      handler(val) {
        let me = this;

        //Nếu validate đang true và kphai custom thì return
        if (
          me.errorProvider &&
          me.errorProvider["isValid"] &&
          (!val || (val && me.errorProvider["rules"] != val.rules))
        ) {
          return;
        }

        if (val && val.isValid) {
          me.$set(me.errorProvider, "message", val.message);
          me.$set(me.errorProvider, "isValid", true);
          me.errorProvider.rules = val.rules;
          me.errorProvider.element = me.$refs.input;
        } else {
          me.errorProvider = {};
        }
      }
    },
    editable: {
      immediate: true,
      handler(val) {
        this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      }
    },
    internalDataSource: {
      immediate: true,
      deep: true,
      handler(val) {
        let me = this;
        if (
          me.useI18nValue &&
          me.internalDataSource &&
          me.internalDataSource.length > 0
        ) {
          me.internalDataSource.forEach(e => {
            let value = e[this.displayField];
            e[me.displayField] = me.$function.handleLocalize(value);
          });
        }
      }
    },
    /**
     * ẩn combobox đang chọn đi khi thằng cha scroll
     * dvquang2 30/08/2021
     */
    scrollParent: {
      immediate: true,

      handler(val) {
        let me = this;
        me.expand(false, false);
      }
    }
  },
  //Hàm khởi tạo dữ liệu hook func
  async created() {
    const me = this;
    me.initCombo();
    me.setInitIndex();
    me.initData();
    if (me.autoLoad) {
      me.doQueryInternal("", false);
    }
  },
  mounted() {
    const me = this;
    //Debounce query để delay load
    if (me.queryMode != "remote") {
      me.internalQueryDelay = 20;
    }
    me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
    if (me.store) {
      me.store.pageAppend = true;
    }
    if (this.autofocus) {
      this.$nextTick(() => this.$refs.input.focus());
    }
  },
  beforeDestroy() {
    const me = this;
    me.firstExpand = false;
    me.expand(false);
    if (me.$refs.dropdownPanel) {
      me.$refs.dropdownPanel.$el.remove();
    }
    document.removeEventListener("click", me.click_out);
    // document.removeEventListener("click", this.closeTabMenu);
  },
  methods: {
    // closeTabMenu(e) {
    //   var specifiedElement = document.getElementById("options");
    //   var isClickInside =
    //     specifiedElement.id.contains(event.target.id) ||
    //     specifiedElement.id.contains(event.target.parentElement.id);
    //   if(!isClickInside){
    //     this.expanded = false;
    //   }
    // },
    /**
     * @override
     */
    focusError(){
      this.expanded = true;
    },

    onDoubleClick() {
      this.permission && this.clickEditBtn();
    },
    resetAll() {
      this.internalDataSource = [];
      this.firstExpand = true;
      this.lastQueryString = undefined;
      this.reset();
    },
    setInitIndex() {
      const me = this;
      if (
        me.initIndex >= 0 &&
        me.internalDataSource &&
        me.internalDataSource.length > 0
      ) {
        me.typeAheadPointer = me.initIndex;
        me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
      }
    },
    /**
     * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
     * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
     * @param start: vị trí bắt đầu của view trong vitual scroll
     * @param end: vị trí kết thúc của view trong vitual scroll
     * Created by LTDAT(30.06.2020)
     *  */
    onScrollerUpdate(start, end) {
      const me = this;
      if (
        end == me.internalDataSource.length &&
        end < me.pageTotalx &&
        start == me.internalDataSource.length - 5 &&
        !me.loading
      ) {
        me.loading = true;
        me.doRemoteQuery(
          me.getQueryString(),
          me.searchColums,
          Math.round(end / 10) + 1
        ).then(x => {
          if (x && x.PageData && x.PageData.length > 0) {
            commonFunc.genVKeyValue(x.PageData);
            me.internalDataSource.push(...x.PageData);
          }
          me.loading = false;
          // me.afterQuery(expand);
        });
      }
    },
    /**
     * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
     * Created by LTDAT(25.06.2020)
     */
    setInitText() {
      const me = this;
      me.initTextX = me.initText;
      me.internalText = me.initTextX;
      if (me.isReloadQueryFuntion) {
        me.isReloadQueryFuntionTemp = true;
        // nếu không phải lần expand đầu tiên => mới query call API
        !this.firstExpand && me.doQueryInternal(me.initTextX);
      }
    },
    /**
     * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
     * CreatedBy LTDAT 11/12/2019
     */
    doQueryInternal(searchString, expand = true) {
      let me = this,
        event = { preventDefault: false, sender: me },
        queryString = searchString != null ? searchString : me.getQueryString();
      me.$emit("beforeQuery", event);
      if (event.preventDefault) {
        return false;
      }
      if (me.lastQueryString == queryString && !me.isReloadQueryFuntionTemp) {
        me.expand(expand);
      } else {
        me.lastQueryString = queryString;
        me.querying = true;
        me.typeAheadPointer = -1;
        if (me.queryMode === "remote" || (me.store && me.store.remoteFilter)) {
          me.loading = true;
          me.showEmptyText = false;
          me.doRemoteQuery(queryString, me.searchColums).then(x => {
            me.internalDataSource = x.PageData;
            if (
              x.PageData[0] &&
              queryString == x.PageData[0][me.displayField]
            ) {
              // set item được chọn
              me.setInternalItem(x.PageData[0]);
            }
            me.pageTotalx = x.Total;
            me.loading = false;
            (!x.PageData || x.PageData == 0) && (me.showEmptyText = true);
            commonFunc.genVKeyValue(me.internalDataSource);
            me.afterQuery(expand);
          });
        } else {
          me.doLocalQuery(queryString).then(x => me.afterQuery(expand));
        }
      }
    },
    /**
     * Hàm convert từ trường tiếng việt sang trường không dấu
     * Created by CVCUONG1 2/2/2021
     */
    stringToSlug(str) {
      if (!str) return "";
      var from =
          "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
        to =
          "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(RegExp(from[i], "gi"), to[i]);
      }

      str = str
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\-]/g, "-")
        .replace(/-+/g, "-");

      return str;
    },
    /**
     * Xử lý sau khi query xong dữ liệu
     * CreatedBy LTDAT 24.06.2020
     */
    afterQuery(expand) {
      const me = this;
      me.expand(expand);
      me.typeAheadPointer = me.filterIndexItemByText();
    },
    /**
     * Query dữ liệu api
     * CreatedBy LTDAT 24.06.2020
     */
    doRemoteQuery(
      queryString,
      searchColums,
      pageIndex = 1,
      typeCombox = this.typeCombox
    ) {
      let me = this;
      return new Promise((resolve, reject) => {
        me.doQueryFuntion(queryString, searchColums, pageIndex, typeCombox)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * Query dữ liệu local
     * CreatedBy LTDAT 24.06.2020
     */
    doLocalQuery(queryString) {
      let me = this,
        store = me.store;

      return new Promise((resolve, reject) => {
        //Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
        let p;
        if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
          var proxy = store.proxy;
          if (proxy && proxy.type === "cache") {
            p = store.load();
          }
        }
        p ? p.then(resolve, reject) : resolve(false);
      }).then(() => {
        me.loading = false;
      });
    },
    /**
     * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
     * CreatedBy LTDAT 11/12/2019
     */
    getQueryString() {
      return (this.internalText || "").trim();
    },
    //Click ra ngoài combo đóng combo lại
    //Created by LTDAT 18.06.2020
    click_out(e) {
      const me = this;
      if (
        me.$el &&
        !commonFunc.hasParent(e.target, me.$el) &&
        me.$refs.dropdownPanel &&
        !commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)
      ) {
        me.expand(false);
        if (!this.internalText) {
          let metaData = {
            oldData: null,
            newData: null
          };
          me.$emit("selected", metaData, me.dataInfo);
        }
      }
    },
    //Reset lại các giá trị trong combobox
    reset() {
      const me = this;
      me.internalText = "";
      me.internalSelectedItem = null;
      me.typeAheadPointer = -1;
      me.internalValue = null;
      me.$emit("input", me.internalValue);
      me.$emit("inputText", me.internalText);
    },
    setInternalText(value) {
      const me = this;
      me.internalText = value;
    },
    setValue(value) {
      const me = this;
      me.internalValue = value;
      me.$emit("input", me.internalValue);
      me.$emit("inputText", me.internalText);
    },
    //Sự kiện nhập liệu trên input
    //Created by LTDAT (16.06.2020)
    onInput(e) {
      const me = this;
      me.initTextX = null;
      if (!me.expanded) {
        me.expand(true);
      }
      if (!me.internalText) {
        if (me.internalValue) {
          let metaData = {
            oldData: me.internalSelectedItem,
            newData: null
          };
          me.$emit("selected", metaData, me.dataInfo);
        }
        me.reset();
      }
      if (me.queryMode == "remote") {
        clearTimeout(this.timeoutQuery);
        this.timeoutQuery = setTimeout(() => {
          me.doQueryInternal(
            me.useSlug ? me.stringToSlug(me.internalText) : me.internalText,
            true
          );
        }, 300);
      } else {
        // Xử lý khi tìm kiếm queryMode = local
        me.showEmptyText = false;
        me.internalDataSource = me.data.filter(d =>
          me
            .stringToSlug(d[this.displayField])
            .toLowerCase()
            .includes(me.stringToSlug(me.internalText).toLowerCase())
        );
        if (me.internalDataSource.length == 0) me.showEmptyText = true;
      }
      me.typeAheadPointer = me.filterIndexItemByText();
      me.validate(me.internalText);
    },
    //Sự kiện focus vào input
    //Created by LTDAT (16.06.2020)
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.isReloadQueryFuntionTemp = false;
      clearTimeout(me.timeoutClickOutside);
    },
    //Sự kiện change input
    //Created by LTDAT (16.06.2020)
    onChange(e) {
      const me = this;
      if (me.autoSetFirstItemWhenEmpty) {
        me.setInternalItem(me.internalDataSource[0]);
      }
      // if (me.focused) {
      //   if (me.forceSelection) {
      //     if (me.typeAheadPointer < 0) {
      //       !me.useAddNew && me.reset();
      //     } else if (me.typeAheadPointer >= 0) {
      //       me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
      //     }
      //   } else {
      //     me.internalValue = me.internalText;
      //     me.$emit("input", me.internalValue);
      //     me.$emit("inputText", me.internalText);
      //   }
      // }
      // if (me.queryMode == "local" && !this.useAddNew) {
      //   me.showEmptyText = false;
      //   me.internalDataSource = me.data;
      // }
    },
    //Sự kiện blur input
    //Created by LTDAT (16.06.2020)
    onBlur(e) {
      if (this.expanded) {
        if (this.isAllowBlurEvent) {
          const me = this;
          me.timeoutClickOutside = setTimeout(() => {
            if (me.focused) {
              if (me.forceSelection) {
                if (
                  (me.typeAheadPointer < 0 || !me.internalText) &&
                  !me.initTextX
                ) {
                  !me.useAddNew && me.reset();
                } else if (
                  me.typeAheadPointer >= 0 &&
                  me.whereUse == "AddSalaryPayment"
                ) {
                  me.setInternalItem(
                    me.internalDataSource[me.typeAheadPointer],
                    false
                  );
                } else if (me.typeAheadPointer >= 0) {
                  me.setInternalItem(
                    me.internalDataSource[me.typeAheadPointer]
                  );
                }
              } else {
                me.internalValue = me.internalText;
                me.$emit("input", me.internalValue);
                me.$emit("inputText", me.internalText);
              }
            }
            if (me.queryMode == "local" && !this.useAddNew) {
              me.showEmptyText = false;
              me.internalDataSource = me.data;
            }
            me.focused = false;
            me.$emit("blur", e);
            me.expand(false, false);

            if (me.useAddNew && me.typeAheadPointer < 0 && me.internalText)
              me.doAddNew();
          }, 200);
        } else {
          this.$refs.input.focus();
        }
      }
    },
    /**
     * Xử lý khi mouse down chuột
     * created by pdthien 24.02.2021
     */
    handleMouseDown() {
      this.isAllowBlurEvent = false;
    },
    /**
     * Xử lý khi mouse up chuột
     * created by pdthien 24.02.2021
     */
    handleMouseUp() {
      this.isAllowBlurEvent = true;
      this.$refs.input.blur();
    },
    //Sự kiện keydown input
    //Created by LTDAT (16.06.2020)
    onKeydown(e) {
      const me = this;
      me.$emit("keydown", e.target.value);
      switch (e.which) {
        case 40:
          {
            if (!me.expanded) {
              me.expand(true);
            } else if (me.typeAheadPointer < me.getTotalData() - 1) {
              if (me.notSelectionParent) {
                let typeAheadPointerNext = me.typeAheadPointer + 1;
                for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
                  me.typeAheadPointer++;
                  me.adjustScroll(typeAheadPointerNext);
                  if (!me.internalDataSource[i].isParent) {
                    break;
                  }
                }
              } else {
                me.typeAheadPointer++;
                me.adjustScroll();
              }
            }
          }
          break;
        case 38:
          {
            if (me.expanded) {
              if (me.typeAheadPointer > 0) {
                if (me.notSelectionParent) {
                  let typeAheadPointerPre = me.typeAheadPointer - 1;
                  for (let i = typeAheadPointerPre; i > 0; i--) {
                    me.typeAheadPointer--;
                    me.adjustScroll(me.typeAheadPointer);
                    if (!me.internalDataSource[i].isParent) {
                      break;
                    }
                  }
                } else {
                  me.typeAheadPointer--;
                  me.adjustScroll();
                }
              }
            }
          }
          break;
        case 13:
          {
            event.preventDefault();
            if (me.typeAheadPointer >= 0) {
              me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
            } else {
              // xử lý thêm khi search không có dữ liệu
              me.useAddNew && me.doAddNew();
              me.showEmptyText = false;
              if (me.queryMode == "local" && !me.useAddNew) {
                me.internalDataSource = me.data;
              }
            }
            me.expand(false);
          }
          break;
        case 9:
          {
            if (me.expanded) {
              me.expand(false);
            }
          }
          break;
      }
    },
    getTotalData() {
      const me = this;
      return me.internalDataSource.length;
    },
    //Bôi màu hightlight cho item
    doHightlightItem() {
      const me = this;
      if (me.internalDataSource) {
        if (me.internalDataSource.length > 0) {
          if (me.internalValue != null && me.internalValue != undefined) {
            //Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
            //Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
            let index = _.findIndex(
              me.internalDataSource,
              item => item[me.valueField] === me.internalValue
            );
            me.typeAheadPointer = index;
          }
        }
      }
    },
    //Tìm kiếm item trong list
    //Created by LTDAT(16.06.2020)
    filterIndexItemByText() {
      const me = this;
      let filters = me.filterFields,
        value = me.internalText,
        index = -1;
      if (filters) {
        index = me.internalDataSource.findIndex((item, _index) => {
          let ret = false;
          for (const key in filters) {
            if (filters.hasOwnProperty(key) && item[key] && value) {
              const s = filters[key];
              if (s == "contains") {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  me
                    .stringToSlug(item[key].toString())
                    .toLowerCase()
                    .includes(me.stringToSlug(value.toString()).toLowerCase());
              } else {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  me
                    .stringToSlug(item[key].toString())
                    .toLowerCase()
                    .startsWith(
                      me.stringToSlug(value.toString()).toLowerCase()
                    );
              }
              if (ret) {
                break;
              }
            }
          }
          return ret;
        });
      }
      me.typeAheadPointer = index;
      me.adjustScroll();
      return index;
    },
    //Lấy cột filter để tìm kiếm local
    //Created by LTDAT 16.06.2020
    getFilterFields() {
      let filter = {};

      if (this.columns && this.columns.length > 0) {
        for (let i = 0; i < this.columns.length; i++) {
          const col = this.columns[i];
          if (!col.filterOperator) {
            col.filterOperator = "contains";
          }
          if (col.dataField && col.filterOperator) {
            if (this.filterColumns && this.filterColumns.length > 0) {
              this.filterColumns.forEach(e => {
                if (!filter.hasOwnProperty(e)) {
                  filter[e] = col.filterOperator;
                }
              });
            } else {
              filter[col.dataField] = col.filterOperator;
            }
          }
        }
      } else {
        filter[this.displayField] = "contains";
      }
      return filter;
    },
    //Lấy element scroll
    //Created by LTDAT (16.06.2020)
    getScroller() {
      if (this.expanded) {
        return this.$refs["scroller"];
      }
      return null;
    },
    /**
     * Di chuyển view đến bản ghi nếu cần
     * @param {Bản ghi cần view} index
     * CreatedBy LTDAT 16.06.2020
     */
    adjustScroll(typeAheadPointer = this.typeAheadPointer) {
      let scroller = this.getScroller();
      if (scroller) {
        scroller.scrollToItem(typeAheadPointer, true);
      }
    },
    onScrollerVisible() {
      const me = this;
      me.adjustScroll();
    },
    //Hàm xử lý khi chọn item trên dropdown
    //Created by LTDAT(16.06.2020)
    onItemClick(item, event) {
      const me = this;
      me.setInternalItem(item);
      me.$refs.input.focus();
    },
    //Set giá trị được chọn
    setInternalItem(item, userAction = true) {
      const me = this;
      me.initTextX = null;
      if (me.notSelectionParent && item.isParent) {
        return;
      }
      let metaData = {
        oldData: me.internalSelectedItem,
        newData: item
      };
      me.internalSelectedItem = item;
      me.internalValue = item[me.valueField];
      me.$emit("input", me.internalValue);
      me.internalText = !me.insertHTML
        ? item[me.displayField]
        : item[me.displayFieldForInput];
      this.validate(this.internalText);
      me.typeAheadPointer = me.findIndexItem(item);
      me.expand(false);
      me.$emit("update:display", me.internalText);
      me.$emit(
        "inputText",
        !me.useI18nValue
          ? item[me.displayField]
          : me.dataTemp[me.typeAheadPointer][me.displayField]
      );
      if (me.useI18nValue) {
        metaData = this.$function._cloneDeep(metaData);
        metaData.newData[me.displayField] =
          me.dataTemp[me.typeAheadPointer][me.displayField];
      }
      if (userAction == true) {
        me.$emit("selected", metaData, me.dataInfo);
      }
    },
    //Tìm vị trị của item trong data
    findIndexItem(item) {
      const me = this;
      return me.internalDataSource.findIndex(_item => {
        return _item == item;
      });
    },
    //Khởi tạo dữ liệu tĩnh mặc định
    initStaticData() {
      const me = this;
      me.comboType = 1;
      me.internalQueryDelay = 200;
      me.filterFields = me.getFilterFields();
      me.internalValue = null;
      me.firstExpand = true;
    },
    //Khởi tạo dữ liệu
    initData() {
      const me = this;
      if (me.store) {
        me.internalDataSource = me.store.data.items;
      } else {
        me.internalDataSource = me.data;
      }
      commonFunc.genVKeyValue(me.internalDataSource);
      //Nếu là combo dạng tree
      if (me.comboType == 3) {
        let data = JSON.parse(JSON.stringify(me.internalDataSource));
        let dataTree = commonFunc.nomalizeDataTree(
          data,
          me.idProperty,
          me.parentIdProperty
        );
        me.internalDataSource = commonFunc.getBodyData(dataTree, true);
      }
    },
    /**
     * Khởi tạo combo
     *
     * @author hngiap - 01.09.2019
     * 1 là combo không có columns (ComboEditor)
     * 2 là combo có columns
     * 3 là combo tree
     */
    initCombo() {
      let me = this;
      if (me.isComboTree) {
        me.comboType = 3;
      } else if (me.columns && me.columns.length !== 0) {
        me.comboType = 2;
      } else {
        me.comboType = 1;
      }
    },
    //Đóng mở combobox
    expand(mode = !this.expanded, callAPI = true) {
      const me = this;
      /***
       * Emit thêm sự kiện để bind dữ liệu
       * LPLONG - 11/01/2021
       */
      this.$emit("expand", mode);
      if (me.firstExpand && callAPI) {
        if (me.queryMode == "remote" && !me.autoLoad) {
          me.doQueryInternal("", true);
        }
        me.firstExpand = false;
      }
      if (mode == true) {
        me.$emit("beforeExpand");
        document.addEventListener("click", me.click_out);
        me.$refs.input && me.$refs.input.focus();
        me.changeDropdownPosition();
      } else {
        document.removeEventListener("click", me.click_out);
      }
      if (!mode) {
        setTimeout(() => {
          me.expanded = mode;
        }, 100);
      } else {
        me.expanded = mode;
      }
      me.doHightlightItem();
      let dropdown =
        this.$refs && this.$refs.dropdownPanel && this.$refs.dropdownPanel.$el;
      if (dropdown) {
        if (mode) {
          dropdown.addEventListener("mousedown", this.handleMouseDown);
          dropdown.addEventListener("mouseup", this.handleMouseUp);
        } else {
          dropdown.removeEventListener("mousedown", this.handleMouseDown);
          dropdown.removeEventListener("mouseup", this.handleMouseUp);
        }
      }
    },
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * TODO: Chưa xử lý khi có scroll
     */
    changeDropdownPosition() {
      let me = this,
        comboEl = me.$el,
        comboElRect = comboEl.getBoundingClientRect(),
        comboMenuEl = me.$el;

      let windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      let windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      me.dropdownLeftx = comboElRect.left;
      me.dropdownTopx = comboElRect.top + comboElRect.height + 2;

      // xử lý điều chỉnh width khi ở chế độ edit trực tiếp
      let btnSaveCancel = this.$refs["btn-save-cancel"];
      let widthBtnSaveCancel = 0;
      if (me.editable && btnSaveCancel)
        widthBtnSaveCancel = btnSaveCancel.clientWidth;

      me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
        ? me.dropdownWidth - widthBtnSaveCancel
        : comboElRect.width - widthBtnSaveCancel;

      // Nếu chạm phải thì align sang trái
      if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
        me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
      }

      // Nếu chạm bottom thì align top
      let maxItemsDisplay = me.maxItemsDisplay;
      if (me.columns && me.columns.length > 0) {
        maxItemsDisplay += 1;
      }
      if (
        comboElRect.bottom + me.itemSize * maxItemsDisplay + 2 >
        windowHeight
      ) {
        me.dropdownTopx =
          comboElRect.top -
          (me.itemSize *
            Math.min(maxItemsDisplay, me.internalDataSource.length) +
            4);
      }
    },
    /**
     * Hàm thêm dữ liệu khi không có dữ liệu
      PDTHIEN 22.12.2020
     */
    doAddNew() {
      this.showEmptyText = false;
      this.$emit("onAddNew", this.internalText);
    },
    handleClickExpandIcon() {
      this.isReloadQueryFuntionTemp = false;
      this.expanded = !this.expanded;
      // call API lấy dữ liệu combobox
      // modified by pdthien 03.10.2020
      if (this.expanded && !this.firstExpand) {
        this.doQueryInternal("", true);
      }
      this.expand(this.expanded);
    },
    /**
     * Hàm focus vào ô input
     * Created by CVCUONG1
     */
    focusInput() {
      this.$refs.input.focus();
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.oldValue = this.value;
        this.editingMode = !this.editingMode;
        this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
        this.$emit("clickEditBtn");
        this.$store.dispatch("setEditingMode", true);
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.$emit("input", this.oldValue);
      this.$emit("closeEditMode");
      this.$store.dispatch("setEditingMode", false);
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      if (!this.errorProvider.isValid) {
        this.$emit(
          "onSaveData",
          this.newAddedItem ? this.newAddedItem : this.internalSelectedItem
        );
        this.$emit("update:newAddedItem", null);
      }
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msCombo.scss";
@import "@/assets/scss/controls/_variables.scss";
.input-disabled {
  background: $input-disable-bg-color !important;
  color: $input-disable-color !important;
}
.no-data {
  -webkit-box-flex: 1;
  padding: 0 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  height: 36px;
}
</style>

<style lang="scss">
.text-border {
  p {
    display: flex;
    flex-direction: column-reverse;
    padding-left: 8px;
  }
  .mi-pencil {
    opacity: 0;
  }
  &:hover {
    .mi-pencil {
      opacity: 1;
    }
  }
}
</style>
